import BaseElement from './BaseElement'
import { Notification } from '../components/Notification';

export default class NotificationElement extends BaseElement {

  renderElement () {
    this.rootElement.render(<Notification />)
  }
}
